import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'

class ArticleCookiesComponent extends Component {
  init() {
    this.buttonAcceptAll = this.element.querySelector('.button--accept-all')
    this.buttonDeclineAll = this.element.querySelector('.button--decline-all')
    this.buttonConfigure = this.element.querySelector('.button--configure')

    this.buttonAcceptAll?.addEventListener('click', () => this.acceptAll())
    this.buttonDeclineAll?.addEventListener('click', () => window.CookieFirst?.declineAllCategories())
    this.buttonConfigure?.addEventListener('click', () => this.configure())

    this.updateText()
    window.addEventListener('cf_init', event => this.updateText(event.detail))
    window.addEventListener('cf_update', event => this.updateText(event.detail))
  }

  acceptAll() {
    window.CookieFirst?.acceptAllCategories()
  }

  declineAll() {
    window.CookieFirst?.withdrawConsent()
  }

  configure() {
    window.CookieFirst?.openPanel('settings')
  }

  updateText(consent = {}) {
    this.status = this.element.querySelector('.article-cookies__status')

    if (!this.status) {
      return
    }

    this.statusAllText = this.status.getAttribute('data-status-all-text')
    this.statusSomeText = this.status.getAttribute('data-status-some-text')
    this.statusNoneText = this.status.getAttribute('data-status-none-text')

    if (!this.statusSomeText || !this.statusAllText || !this.statusNoneText) {
      return
    }

    consent = consent || window.CookieFirst?.consent || {}
    const consentKeys = Object.keys(consent).filter(key => key && key !== 'necessary')

    if (!consent || !consentKeys.length) {
      return
    }

    if (consentKeys.reduce((acc, key) => acc && consent[key], true)) {
      this.status.textContent = this.statusAllText
    } else if (consentKeys.reduce((acc, key) => acc || consent[key], false)) {
      this.status.textContent = this.statusSomeText
    } else {
      this.status.textContent = this.statusNoneText
    }
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'article-cookies', ArticleCookiesComponent))
